import { render, staticRenderFns } from "./Sheet.vue?vue&type=template&id=147232af&scoped=true"
import script from "./Sheet.vue?vue&type=script&lang=ts"
export * from "./Sheet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147232af",
  null
  
)

export default component.exports